import {XCircleIcon, XCloseIcon} from '@/components/ui/icon/Icon'
import {StyledLoginErrorMessage, StyledLoginErrorMessageParagraph, StyledLoginErrorMessageTitle} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n.tsx'
import {useTheme} from 'styled-components'
import {Button} from '@/components/ui/button/Button'

export const LoginErrorMessage = ({hideMessage}: {hideMessage: () => void}) => {
    const {t} = useTranslation()
    const {palette} = useTheme()

    return (
        <StyledLoginErrorMessage align="flex-start" gap={2}>
            <XCircleIcon size={20} color={palette.danger[500]} />
            <Flexbox direction="column">
                <StyledLoginErrorMessageTitle>{t('login:failed_access_title')}</StyledLoginErrorMessageTitle>
                <StyledLoginErrorMessageParagraph>
                    {t('login:failed_access_paragraph')}
                </StyledLoginErrorMessageParagraph>
            </Flexbox>
            <Button size="sm" variant="ghost" shape="text" onClick={hideMessage}>
                <XCloseIcon />
            </Button>
        </StyledLoginErrorMessage>
    )
}
